const LANGUAGE_NAMES = {
  en: 'English',
  es: 'Spanish',
  fr: 'French',
  de: 'German',
  it: 'Italian',
  pt: 'Portuguese',
  nl: 'Dutch',
  ru: 'Russian',
  ja: 'Japanese',
  ko: 'Korean',
  'zh-CN': 'Chinese (Simplified)',
  'zh-TW': 'Chinese (Traditional)',
  ar: 'Arabic',
  hi: 'Hindi',
  pl: 'Polish',
  tr: 'Turkish',
  sv: 'Swedish',
  no: 'Norwegian',
  da: 'Danish',
  fi: 'Finnish',
  he: 'Hebrew',
  th: 'Thai',
  vi: 'Vietnamese',
  id: 'Indonesian',
  cs: 'Czech',
  ro: 'Romanian',
  hu: 'Hungarian',
  el: 'Greek',
  uk: 'Ukrainian',
  bg: 'Bulgarian',
  hr: 'Croatian',
};

const LANGUAGE_TO_COUNTRY_CODE = {
  en: 'us',
  es: 'es',
  fr: 'fr',
  de: 'de',
  it: 'it',
  pt: 'pt',
  nl: 'nl',
  ru: 'ru',
  ja: 'jp',
  ko: 'kr',
  'zh-CN': 'cn',
  'zh-TW': 'tw',
  ar: 'sa',
  hi: 'in',
  pl: 'pl',
  tr: 'tr',
  sv: 'se',
  no: 'no',
  da: 'dk',
  fi: 'fi',
  he: 'il',
  th: 'th',
  vi: 'vn',
  id: 'id',
  cs: 'cz',
  ro: 'ro',
  hu: 'hu',
  el: 'gr',
  uk: 'ua',
  bg: 'bg',
  hr: 'hr',
};

function getLanguageName(code) {
  if(!code) {
    return code;
  }
  return LANGUAGE_NAMES[code] || code;
}

function getFlagUrl(code) {
  if(!code) {
    return null;
  }
  const countryCode = LANGUAGE_TO_COUNTRY_CODE[code] || code.toLowerCase();
  return `https://flagcdn.com/16x12/${countryCode}.png`;
}

module.exports = {
  LANGUAGE_NAMES,
  getLanguageName,
  getFlagUrl,
  paymentSources: {
    WIX: 'wix',
    STRIPE: 'stripe',
  },
  paymentPeriods: {
    MONTHLY: 'monthly',
    YEARLY: 'yearly',
  },
  reviewTypes: {
    TEXT: 'TEXT',
    AUTO: 'AUTO',
    VIDEO: 'VIDEO',
  },
  ROLE_LEVELS: {
    owner: { name: 'Owner', level: 1 },
    admin: { name: 'Admin', level: 2 },
    editor: { name: 'Editor', level: 3 },
    viewer: { name: 'Viewer', level: 4 },
  },
  ROLE_COLORS: {
    owner: { bg: 'bg-red-100', text: 'text-red-700' },
    admin: { bg: 'bg-purple-100', text: 'text-purple-700' },
    editor: { bg: 'bg-green-100', text: 'text-green-700' },
    viewer: { bg: 'bg-yellow-100', text: 'text-yellow-700' },
  },
};
